import round from './round';

const getRabatt = (zwischensumme, weeklyDiscountPercentage) => {
  const rabatt = zwischensumme * (weeklyDiscountPercentage / 100);
  return round(rabatt);
};

export default getRabatt;
